import type { VoidFunctionComponent } from 'react';

import FilterCard from '../../generic/Filter/FilterCard';
import type { AnyFilter } from '../../../../shared/organizationPackages/filters';

import VulnCVE from './VulnCVE';
import VulnCWE from './VulnCWE';
import VulnHasFix from './VulnHasFix';
import VulnSeverity from './VulnSeverity';

/**
 * PackageInventoryFiltersVuln has filters related to
 * searching packages by vuln CVE, CWE, severity, and fixability.
 */
type Props = {
  filters: AnyFilter;
  setFilters: (filters: AnyFilter) => void;
};

const PackageInventoryFiltersVuln: VoidFunctionComponent<Props> = ({ filters, setFilters }) => {
  const cve = filters.cve ?? '';
  const cwes = filters.cwes ?? [];
  return (
    <FilterCard id="package-inventory-vuln-filters" title="Vulnerabilities">
      <VulnCVE cve={cve} setFilters={setFilters} />
      <VulnCWE cwes={cwes} setFilters={setFilters} />
      <VulnSeverity severities={filters.severities ?? []} setFilters={setFilters} />
      <VulnHasFix fixTypes={filters.fixTypes ?? []} setFilters={setFilters} />
    </FilterCard>
  );
};

export default PackageInventoryFiltersVuln;
